import { Slot } from "@radix-ui/react-slot";
import { type VariantProps, cva } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const button = cva(
  "inline-flex items-center justify-center gap-1.5 rounded-[3px] text-[13px] font-bold transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bur",
  {
    variants: {
      variant: {
        primary: "bg-bur text-white hover:bg-bur-d",
        outline: "border border-line bg-card text-ink2 hover:bg-bur-xl",
        ghost: "text-ink2 hover:bg-line2",
        danger: "bg-warn text-white hover:brightness-90",
      },
      size: {
        sm: "h-7 px-2.5 text-nota",
        md: "h-9 px-4",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof button> {
  asChild?: boolean;
}

export function Button({ className, variant, size, asChild, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : "button";
  return <Comp className={cn(button({ variant, size }), className)} {...props} />;
}
